/**
 * Shared handoff categories used across handoff tools and detection systems.
 * Update this file to add or modify handoff categories.
 */

import * as z from "zod";

export const HANDOFF_CATEGORIES = [
  "CUSTOMER_FRUSTRATED",
  "CUSTOMER_EXPLICITLY_REQUESTED",
  "TOOL_FAILURE",
  "OUTSIDE_CAPABILITIES",
  "COMPLEX_ISSUE",
  "POLICY_EXCEPTION_NEEDED",
  "ACCOUNT_ISSUE",
  "OTHER",
] as const;

export type HandoffCategory = (typeof HANDOFF_CATEGORIES)[number];

export const HandoffCategorySchema = z.enum(HANDOFF_CATEGORIES);

export const HANDOFF_CATEGORY_DESCRIPTIONS = {
  CUSTOMER_FRUSTRATED: "Customer expressed frustration or anger",
  CUSTOMER_EXPLICITLY_REQUESTED:
    "Customer directly asked to speak with a human",
  TOOL_FAILURE: "AI mentioned tools or actions were failing",
  OUTSIDE_CAPABILITIES: "AI indicated the request is beyond its capabilities",
  COMPLEX_ISSUE: "Issue is too complex for the AI to handle",
  POLICY_EXCEPTION_NEEDED: "Customer needs a policy exception",
  ACCOUNT_ISSUE: "Account-related problems",
  OTHER: "Use this if none of the above fit, and suggest a better category",
} as const;

export function handoffCategoryToDisplayName(
  category: HandoffCategory,
): string {
  return category
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
